export const groupBys = [
        { key: "quoteGroupDescription", label: "Build Group" },
        { key: "salesforceCode", label: "Salesforce Code" },
        { key: "supplierName", label: "Supplier" },
        { key: "itemLookupType", label: "Item Type" },
        { key: "businessCOE", label: "Business COE" }
]